/**
 * Created by hao.cheng on 2017/4/16.
 */
import React from 'react';
import classnames from 'classnames'
import {omit, pick} from 'lodash'

class Iconfont extends React.Component {
    render() {
        const propsClassName = pick(this.props, ["className"])
        const htmlAttrs = omit(this.props, ["className"])

        const propsClassNameVal= propsClassName && propsClassName.className;
        return (
            <i className={classnames('icon', this.props.libname, propsClassNameVal, [`${this.props.libname}-${this.props.type}`])}  {...htmlAttrs}/>
        )
    }
}

export default Iconfont;


// WEBPACK FOOTER //
// ./src/components/Iconfont/Iconfont.jsx